module.exports = __webpack_public_path__ + "f75059b1426673f8eaea5b3757d56000.svg";